<template>
  <div id="sidebar"
       :class="{'sidebar-collapsed': collapsed}"
  >
    <nav>
      <slot name="default"></slot>
    </nav>
    <div class="sidabar-separator"></div>
    <div class="sidebar-help-box">
      <template v-if="helpMessage">
        <p v-for="(m, $index) in helpMessage"
           :key="$index"
        >
          {{ m }}
        </p>
      </template>
    </div>
    <div class="sidebar-collapser"
         @click="toggleCollapsed()"
    >
      <i v-if="collapsed"
         class="fas fa-arrow-right"
      ></i>
      <i v-else
         class="fas fa-arrow-left"
      ></i>
    </div>
    <div v-if="collapsed"
         id="footer"
    >
      <a href="https://www.arit.cz/"
         target="_blank"
      >
        <img src="../../assets/logo_arit.png"
             width="16"
             height="16"
        />
      </a><br />
      <strong>1.8.0</strong><br />
      <strong>8caf5fe35c59</strong>
    </div>
    <div v-else
         id="footer"
    >
      &copy; 2019 - 2021
      <a href="https://www.arit.cz/"
         target="_blank"
      >
        <img src="../../assets/logo_arit.png"
             width="24"
             height="24"
        />
      </a><br />
      verze UI: <strong>{{ UI_VERSION_TAG }}</strong><br />
      verze API: <strong>{{ API_VERSION_TAG }}</strong><br />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import EventBus from 'CORE/bus'
import { VERSION_TAG } from '@/versions'

const parseHelpMessageText = txt => _.split(txt, '|')
const LOCALSTORAGE_COLLAPSED_KEY = 'asd-sidebar-collapsed'

export default {
    name: 'TheSideBar',
    components: {
    },
    props: {
    },
    data() {
        return {
            collapsed: false,
            helpMessage: false,
        }
    },
    computed: {
        UI_VERSION_TAG() {
            return VERSION_TAG
        },
        API_VERSION_TAG() {
            return _.get(this.$store.getters.apiInfo, 'apiVersion', '<unknown>')
        },
    },
    mounted() {
        EventBus.$on('SHOW_HELP', message => {
            if (message === false) {
                this.helpMessage = false
            } else {
                this.helpMessage = parseHelpMessageText(message)
            }
        })
        this.collapsed = window.localStorage.getItem(LOCALSTORAGE_COLLAPSED_KEY) === 'true'
    },
    methods: {
        toggleCollapsed() {
            this.collapsed = !this.collapsed
            window.localStorage.setItem(LOCALSTORAGE_COLLAPSED_KEY, this.collapsed)
        },
    },
}
</script>

<style scoped lang="scss">
@keyframes change-color {
  0%{ background-color: Gold; }
  100%{ background-color: whitesmoke; }
}

.sidebar-help-box {
  margin: 0;
  background-color: whitesmoke;
  color: black;
  border-right: 1px dashed var(--color-primary);
  background-image: url('../../assets/sidebar-arrow-down.png');
  background-repeat: no-repeat;
  background-position: top 0px center;
  width: 100%;
  max-width: 200px;
  font-size: 0.9rem;
  font-weight: bold;
  transition: all 250ms ease-out;
  text-align: justify;
  &:empty {
    height: 0;
    padding: 0;
    widows: 0;
  }
  &:not(:empty) {
    max-height: 40vh;
    overflow-y: auto;
    padding: 15px 9px 10px 9px;
    animation: change-color 500ms ease-in-out 0.5s 1 normal;
  }
}


#sidebar {
  background-color: var(--color-primary);
  color: var(--color-primary-inverse);
  display: flex;
  flex-direction: column;
  nav {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    width: 200px;
    transition: all 100ms;
    & > a {
      padding: 5px;
      color: white;
      // text-transform: uppercase;
      &.l1 {
          padding-left: 1.2rem;
      }
      &.l2 {
          padding-left: 2.4rem;
      }
      &.router-link-active {
        background-color: rgba(255, 255, 255, 0.2);
        background-image: url('../../assets/sidebar-arrow.png');
        background-repeat: no-repeat;
        background-position: right 0px center;
        width: 210px;
      }
      &:hover {
        background-color: rgba(255, 255, 255, 0.8);
        color: var(--color-primary);
      }
      &:hover {
        text-decoration: none;
      }
      &>i.fas {
        margin-right: 5px;
      }
    }
    hr.separator {
        width: calc(100% - 10px);
        border-color: rgba(255,255,255,0.4);
        margin: 10px 0.2rem;
        border-style: dashed;
    }
  }
  .sidabar-separator {
    flex-grow: 1;
  }
  .sidebar-collapser {
    background-color: darkred;
    text-align: center;
    cursor: pointer;
    &:hover {
      background-color: firebrick;
    }
  }
}

.sidebar-collapsed  {
    nav {
        width: 60px !important;
        font-size: 0.5rem;
    }
    .sidebar-help-box {
        max-width: 60px;
        display: none;
    }
}

#footer {
    background-color: black;
    padding: 5px;
    text-align: center;
    font-size: 0.7rem;
}
</style>
